import Call from '../../Call';

const Feeds = {
    get() {
        return Call(`adkBanner/feeds`);
    },

    getIds() {
        return Call(`adkBanner/feeds/ids`);
    },

    save(feed) {
        return Call('adkBanner/feeds','POST', feed);
    },

    update(id, feed) {
        return Call(`adkBanner/feeds/${id}`,'PUT', feed);
    },

    remove(id) {
        return Call(`adkBanner/feeds/${id}`,'DELETE');
    },

    sync() {
        return Call(`adkBanner/feeds/sync`);
    },
};

export default Feeds;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBanner/Feeds.js